import React, { useEffect, useState } from "react";
import "../styles/FlipbookLayout.css";
import Header from "./Header";
import header from "../assets/images/heder.jpeg"
import Loader from "../utilities/Loader";
import config from "../services/config";
const BASE_URL = process.env.REACT_APP_FILE_BASE_URL;

export default function FlipbookLayout() {
  const [data, setData] = useState([]);
  const [activeBook, setActiveBook] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visitorCount, setVisitorCount] = useState(11000);
  const [aids, setAids] = useState([]);

  /* ================= RESOURCE DATA ================= */
  const resourceData = async () => {
    try {
      setLoading(true);

      const payload = {
        company_id: 1,
        category_id: 1,
      };

      const Res = await config.getResourceDetails(payload);
      console.log("Resource Response:", Res);

      if (Res?.success === true && Res?.data?.length > 0) {
        setData(Res.data);
        setActiveBook(Res.data[0]); // ✅ auto select first book
      }
    } catch (error) {
      console.error("❌ Error fetching resources:", error);
    } finally {
      setLoading(false);
    }
  };

  /* ================= VISITOR COUNT ================= */
  const getVisitorCounts = async () => {
    try {
      const res = await config.getVisitorCount();
      console.log("Visitor Count Response:", res);

      if (res?.count) {
        setVisitorCount(res.count);
      } else {
        setVisitorCount("11104");
      }
    } catch (error) {
      console.error("Error getting visitor count:", error);
      setVisitorCount("11104");
    }
  };

  /* ================= INCREASE VISITOR COUNT ================= */
  const increaseVisitorCount = async () => {
    try {
      await config.increaseVisitorCount();
      await getVisitorCounts(); // Refresh the visitor count
    } catch (error) {
      console.error("Error increasing visitor count:", error);
    }
  };

  /* ================= GET IMAGES (DYNAMIC) ================= */
  // const getImages = async (resourceId) => {
  //   try {
  //     const payload = {
  //       company_id: 1,
  //       id: resourceId,
  //     };

  //     const res = await config.getPhotographyImage(payload);
  //     console.log("Images Response:", res);

  //     if (res?.success === true && res?.data?.length > 0) {
  //       setImages(res.data);
  //     } else {
  //       setImages([]);
  //     }
  //   } catch (error) {
  //     console.error("Error getting images:", error);
  //     setImages([]);
  //   }
  // };

  /* ================= GET ALL ACTIVE ADS ================= */
  const getAllActiveAds = async () => {
    try {
      const res = await config.getAllActiveAds();
      if (res?.status && res?.data?.length > 0) {
        console.log("Active Ads:", res.data);
        setAids(res.data);
      } else {
        console.log("No active ads found.");
      }
      console.log("Active Ads Response:", res);
    } catch (error) {
      console.error("Error getting active ads:", error);
    }
  };

  /* ================= INITIAL LOAD ================= */
  useEffect(() => {
    resourceData();
    // getVisitorCount();
    increaseVisitorCount();
    getAllActiveAds();
  }, []);

  /* ================= LOAD IMAGES WHEN BOOK CHANGES ================= */
  // useEffect(() => {
  //   if (activeBook?.id) {
  //     getImages(activeBook.id);
  //   }
  // }, [activeBook]);

  return (
    <div className="page-wrapper">
      {/* HEADER */}
      <div className="header">
        <img src={header} alt="Newspaper Header" />
      </div>

      {loading && <Loader />}

      <div className="content">
        {/* LEFT PANEL */}
        <div className="left-panel">
          <div className="panel-title">Archived Issues</div>

          {data.map((book) => (
            <div
              key={book.id}
              className={`archive-item ${activeBook?.id === book.id ? "active" : ""
                }`}
              onClick={() => setActiveBook(book)}
            >
              {book.name}
            </div>
          ))}
        </div>

        {/* CENTER PANEL */}
        <div className="center-panel">
          <div className="book-info-row">
            <div className="date-strip">
              {activeBook?.from_date} to {activeBook?.to_date}
            </div>
            {/* Download Button */}
            <div
              className="download-btn date-strip"
              onClick={() => {
                if (activeBook?.inerve_pdf) {
                  const fileUrl = BASE_URL + activeBook.inerve_pdf;
                  window.open(fileUrl, "_blank");
                }
              }}
            >
              Download
            </div>
          </div>

          {activeBook?.url && (
            <iframe
              src={activeBook.url}
              title="Flipbook Viewer"
              allowFullScreen
            />
          )}
        </div>

        {/* VISITOR COUNTER */}
        <div className="visitor-counter">
          You are Visitor no: {visitorCount}
        </div>

        {/* RIGHT PANEL */}
        <div className="right-panel">
          <div className="ads-list">
            {aids.map((ad) => (
              <div
                key={ad.id}
                className="ad-item"
                style={{
                  borderBottom: "2px solid #2c2b2b",
                  paddingBottom: "15px",
                  marginBottom: "15px",
                }}
              >
                <img
                  src={ad.photos?.[0]}
                  alt="Advertisement"
                  onClick={() => window.open(ad.url, "_blank")}
                  style={{
                    cursor: "pointer",
                    width: "100%",
                    height: "180px",
                    objectFit: "contain",
                    display: "block",
                    margin: "0 auto",
                  }}
                />

                {ad.about && (
                  <p
                    style={{
                      marginTop: "8px",
                      fontSize: "14px",
                      color: "#555",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: 2, // approx 10-20 words
                      WebkitBoxOrient: "vertical",
                      lineHeight: "1.4",
                    }}
                  >
                    {ad.about}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}